import { t } from "@excalidraw/excalidraw/i18n";
import { useState } from "react";

import "./PresentationExitDialog.scss";

interface Props {
  onSavePdf: () => Promise<void> | void;
  onSaveAsNewBoard: () => Promise<void> | void;
  onDiscard: () => void;
  onCancel: () => void;
}

export const PresentationExitDialog = ({
  onSavePdf,
  onSaveAsNewBoard,
  onDiscard,
  onCancel,
}: Props) => {
  const [busy, setBusy] = useState(false);

  const run = (fn: () => Promise<void> | void) => async () => {
    setBusy(true);
    try {
      await fn();
    } finally {
      setBusy(false);
    }
  };

  return (
    <div
      className="pw-exit-modal"
      onMouseDown={(e) => {
        if (e.target === e.currentTarget && !busy) {
          onCancel();
        }
      }}
    >
      <div className="pw-exit-modal__dialog">
        <h2>{t("presentation.exitTitle")}</h2>
        <p>{t("presentation.exitMessage")}</p>
        <div className="pw-exit-modal__actions">
          <button
            type="button"
            className="pw-exit-modal__btn pw-exit-modal__btn--primary"
            disabled={busy}
            onClick={run(onSavePdf)}
          >
            {t("presentation.savePdf")}
          </button>
          <button
            type="button"
            className="pw-exit-modal__btn pw-exit-modal__btn--primary"
            disabled={busy}
            onClick={run(onSaveAsNewBoard)}
          >
            {t("presentation.saveAsNewBoard")}
          </button>
          <button
            type="button"
            className="pw-exit-modal__btn pw-exit-modal__btn--danger"
            disabled={busy}
            onClick={onDiscard}
          >
            {t("presentation.discard")}
          </button>
          <button
            type="button"
            className="pw-exit-modal__btn"
            disabled={busy}
            onClick={onCancel}
          >
            {t("presentation.cancel")}
          </button>
        </div>
      </div>
    </div>
  );
};
